<template>
  <header class="top">
    <div class="top-cont">
      <a
        class="logo nav-mobile-hide"
        onClick="gtag('event', 'LOGO', {'event_category' : '导航栏', 'event_label' : 'click1'});"
        href="https://ai.arcsoft.com.cn"
        title="虹软"
      ></a>
      <a
        class="login-icon-mobile"
        onclick="gtag('event', '登录图标', {'event_category' : '手机端-导航栏', 'event_label' : 'mobile-button07'})"
        href="/ucenter/resource/build/index.html#/login"
        ><img src="/resource/images/logining-icon.png" alt=""
      /></a>
      <div class="list-nav-cont nav-mobile-hide">
        <ul>
          <li>
            <a data-href="product">开放产品</a>
            <dl style="width:350px;padding-top: 15px;padding-right: 30px">
              <dd class="title1">SDK 产品</dd>
              <div class="solution-1">
                <dd style="width: 150px">
                  <a href="/product/arcface_pro.html"
                    ><i>›</i>人脸识别增值版
                    <b
                      style="color: #ffa500;height: 12px;font-size: 12px;line-height: 20px;font-weight: normal;position:relative;left:8px"
                      >Hot</b
                    >
                  </a>
                </dd>
                <dd>
                  <a
                    href="/product/arcface.html"
                    onclick="gtag('event', '开放产品-人脸识别SDK', {'event_category' : '导航栏', 'event_label' : 'click8'});"
                    ><i>›</i>人脸识别SDK<b
                      style="color: #ffa500;height: 12px;font-size: 12px;line-height: 20px;font-weight: normal;position:relative;left:8px"
                      >Hot</b
                    >
                  </a>
                </dd>
                <dd style="width: 170px">
                  <a href="/product/RV1109.html"
                    ><i>›</i>人脸识别 ARM Linux<b
                      style="color: #bf0000;height: 12px;font-size: 12px;line-height: 20px;font-weight: normal;position:relative;left:8px"
                      >New</b
                    >
                  </a>
                </dd>
                <dd style="width: 113px;">
                  <a
                    href="/product/verification.html"
                    onclick="gtag('event', '开放产品-人证核验SDK', {'event_category' : '导航栏', 'event_label' : 'click9'});"
                    ><i>›</i>人证核验SDK
                  </a>
                </dd>

                <dd>
                  <a href="/product/arcface_app.html"
                    ><i>›</i>APP人脸识别增值版</a
                  >
                </dd>
              </div>
              <dd class="title2">应用产品</dd>
              <div class="solution-2">
                <dd>
                  <a
                    href="/product/arcfacego.html"
                    onclick="gtag('event', '开放产品-应用套件', {'event_category' : '导航栏', 'event_label' : 'click12'});"
                    class="nav-indent"
                    ><i>›</i>应用套件<b
                      style="color: #00db5f;height: 12px;font-size: 12px;line-height: 20px;font-weight: normal;position:relative;left:8px"
                      >开源</b
                    >
                  </a>
                </dd>
                <dd style="width: 105px;">
                  <a href="/product/arcoffice.html" class="nav-indent"
                    ><i>›</i>人脸考勤系统</a
                  >
                </dd>
                <dd>
                  <a
                    href="/product/dev-tools.html"
                    onclick="gtag('event', '开放产品-开发套件', {'event_category' : '导航栏', 'event_label' : 'click11'});"
                    class="nav-indent"
                    ><i>›</i>开发套件</a
                  >
                </dd>
              </div>
            </dl>
          </li>
          <li>
            <a data-href="technology">核心技术</a>
            <dl class="solution-first">
              <div>
                <dd>
                  <a
                    href="/technology/faceDetection.html"
                    onClick="gtag('event', '核心技术-人脸检测', {'event_category' : '导航栏', 'event_label' : 'click2'});"
                    ><i>›</i>人脸检测</a
                  >
                </dd>
                <dd>
                  <a
                    href="/technology/faceTracking.html"
                    onClick="gtag('event', '核心技术-人脸跟踪', {'event_category' : '导航栏', 'event_label' : 'click3'});"
                    ><i>›</i>人脸跟踪</a
                  >
                </dd>
                <dd>
                  <a
                    href="/technology/faceContrast.html"
                    onClick="gtag('event', '核心技术-人脸比对', {'event_category' : '导航栏', 'event_label' : 'click4'});"
                    ><i>›</i>人脸比对</a
                  >
                </dd>
                <dd>
                  <a
                    href="/technology/faceLookup.html"
                    onClick="gtag('event', '核心技术-人脸查找', {'event_category' : '导航栏', 'event_label' : 'click5'});"
                    ><i>›</i>人脸查找</a
                  >
                </dd>
                <dd>
                  <a
                    href="/technology/faceAttribute.html"
                    onClick="gtag('event', '核心技术-人脸属性分析', {'event_category' : '导航栏', 'event_label' : 'click6'});"
                    ><i>›</i>人脸属性分析</a
                  >
                </dd>
                <dd>
                  <a
                    href="/technology/liveness.html"
                    onClick="gtag('event', '核心技术-活体检测', {'event_category' : '导航栏', 'event_label' : 'click7'});"
                    ><i>›</i>活体检测</a
                  >
                </dd>
              </div>
            </dl>
          </li>

          <li>
            <a data-href="solution">应用方案</a>
            <dl style="width:332px" class="application">
              <dd class="title1">应用方案</dd>
              <div class="solution-1" style="width: 322px">
                <dd>
                  <a
                    href="/solution/verification.html"
                    onclick="gtag('event', '应用方案-人证核验应用方案', {'event_category' : '导航栏', 'event_label' : 'click13'});"
                    ><i>›</i>人证核验应用方案</a
                  >
                </dd>
                <dd style="margin-right: 23px">
                  <a
                    href="/solution/building.html"
                    onclick="gtag('event', '应用方案-人脸门禁应用方案', {'event_category' : '导航栏', 'event_label' : 'click14'});"
                    ><i>›</i>人脸门禁应用方案</a
                  >
                </dd>
              </div>
              <dd class="title2">解决方案</dd>
              <div class="solution-2">
                <dd style="width: 116px;">
                  <a
                    href="/industry/construction.html"
                    onclick="gtag('event', '解决方案-智慧工地', {'event_category' : '导航栏', 'event_label' : 'click15'});"
                    ><i>›</i>智慧工地</a
                  >
                </dd>

                <dd style="width: 147px;">
                  <a
                    href="/industry/scenic.html"
                    onclick="gtag('event', '解决方案-智慧景区', {'event_category' : '导航栏', 'event_label' : 'click16'});"
                    ><i>›</i>智慧景区</a
                  >
                </dd>
                <dd>
                  <a
                    href="/industry/community.html"
                    onclick="gtag('event', '解决方案-智慧社区', {'event_category' : '导航栏', 'event_label' : 'click17'});"
                    ><i>›</i>智慧社区</a
                  >
                </dd>
                <dd style="width: 147px;">
                  <a
                    href="/industry/work.html"
                    onclick="gtag('event', '解决方案-智慧办公', {'event_category' : '导航栏', 'event_label' : 'click18'});"
                    ><i>›</i>智慧办公</a
                  >
                </dd>
                <dd>
                  <a
                    href="/industry/hotel.html"
                    onclick="gtag('event', '解决方案-智慧酒店', {'event_category' : '导航栏', 'event_label' : 'click19'});"
                    ><i>›</i>智慧酒店</a
                  >
                </dd>
                <dd style="width: 147px">
                  <a
                    href="/industry/school.html"
                    onclick="gtag('event', '解决方案-智慧校园', {'event_category' : '导航栏', 'event_label' : 'click20'});"
                    ><i>›</i>智慧校园</a
                  >
                </dd>
              </div>
            </dl>
          </li>

          <li>
            <a data-href="usercase">客户案例</a>
            <dl class="example">
              <dd>
                <a
                  href="/usercase/kdbl.html"
                  onclick="gtag('event', '客户案例-智慧校园', {'event_category' : '导航栏', 'event_label' : 'click21'});"
                  ><i>›</i>智慧校园</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/zld.html"
                  onclick="gtag('event', '客户案例-智慧工地', {'event_category' : '导航栏', 'event_label' : 'click22'});"
                  ><i>›</i>智慧工地</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/shrt.html"
                  onclick="gtag('event', '客户案例-智慧景区', {'event_category' : '导航栏', 'event_label' : 'click23'});"
                  ><i>›</i>智慧景区</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/zzw.html"
                  onclick="gtag('event', '客户案例-智慧社区', {'event_category' : '导航栏', 'event_label' : 'click24'});"
                  ><i>›</i>智慧社区</a
                >
              </dd>
            </dl>
          </li>

          <li>
            <a
              href="/course/index.html"
              onclick="gtag('event', '公开课', {'event_category' : '导航栏', 'event_label' : 'click25'});"
              >公开课</a
            >
          </li>
          <li>
            <a
              href="/market/index.html"
              onclick="gtag('event', '产业链市场', {'event_category' : '导航栏', 'event_label' : 'click166'});"
              >产业链市场</a
            >
            <sup><img src="/resource/images/new_nav.png" alt=""/></sup>
          </li>
          <li>
            <a
              href="/news/index.html"
              onclick="gtag('event', '新闻资讯', {'event_category' : '导航栏', 'event_label' : 'click26'});"
              >新闻资讯</a
            >
          </li>

          <li>
            <a data-href="manual">帮助与支持</a>
            <dl class="help">
              <dd>
                <a
                  href="/manual/docs#/41"
                  target="_blank"
                  onclick="gtag('event', '帮助与支持-新手指南', {'event_category' : '导航栏', 'event_label' : 'click27'});"
                  ><i>›</i>新手指南</a
                >
              </dd>
              <dd>
                <a
                  href="/manual/docs#/42"
                  target="_blank"
                  onclick="gtag('event', '帮助与支持-常见问题', {'event_category' : '导航栏', 'event_label' : 'click28'});"
                  ><i>›</i>常见问题</a
                >
              </dd>
              <dd>
                <a
                  href="/manual/docs#/123"
                  target="_blank"
                  onclick="gtag('event', '帮助与支持-API文档', {'event_category' : '导航栏', 'event_label' : 'click29'});"
                  ><i>›</i>SDK文档</a
                >
              </dd>
            </dl>
          </li>
          <li class="beforeUserLogin" style="display: inline-block">
            <a
              class="developer-center"
              href="/ucenter/resource/build/index.html#/index"
              onclick="gtag('event', '开发者中心', {'event_category' : '导航栏', 'event_label' : 'click31'});"
              >开发者中心</a
            >
          </li>
          <li class="afterUserLogin" style="display: none">
            <div class="developer-user">
              <p class="login-icon">
                <a
                  class="developer-user-center"
                  href="/ucenter/resource/build/index.html#/index"
                  onclick="gtag('event', '开发者中心', {'event_category' : '导航栏', 'event_label' : 'click31'});"
                  >开发者中心</a
                >
              </p>
              <dl>
                <dd class="userinfo-name">
                  <a
                    href="/ucenter/resource/build/index.html#/account"
                    onclick="gtag('event', '开发者中心-用户名', {'event_category' : '导航栏', 'event_label' : 'click32'});"
                  ></a>
                </dd>
                <dd class="userinfo-account">
                  <a
                    href="/ucenter/resource/build/index.html#/accountMiddle?from=account"
                    onclick="gtag('event', '开发者中心-认证', {'event_category' : '导航栏', 'event_label' : 'click33'});"
                  ></a>
                </dd>
                <dd class="userinfo-link">
                  <a
                    href="/ucenter/resource/build/index.html#/account"
                    onclick="gtag('event', '开发者中心-个人信息', {'event_category' : '导航栏', 'event_label' : 'click34'});"
                    >个人信息</a
                  >
                </dd>
                <dd class="logout">
                  退出登录
                </dd>
              </dl>
            </div>
          </li>
        </ul>
        <div class="menu"></div>
      </div>
    </div>

    <nav class="top-nav">
      <div class="nav-close-cont">
        <img class="mobile-nav-btn" src="/resource/images/mobile-nav-btn.png" />
      </div>
      <ul>
        <li>
          <div class="nav-two technology">
            <dl class="technology-middle">
              <dt><a href="#">开放产品</a></dt>
              <dd><a class="nav-indent-title">应用方案</a></dd>
              <dd>
                <a
                  href="/product/arcface.html"
                  class="nav-indent"
                  onclick="gtag('event', '开放产品-人脸识别SDK', {'event_category' : '导航栏', 'event_label' : 'click8'});"
                  ><i>›</i>人脸识别SDK</a
                >
              </dd>
              <dd>
                <a
                  href="/product/verification.html"
                  class="nav-indent"
                  onclick="gtag('event', '开放产品-人证核验SDK', {'event_category' : '导航栏', 'event_label' : 'click9'});"
                  ><i>›</i>人证核验SDK</a
                >
              </dd>

              <dd>
                <a href="/product/arcface_pro.html" class="nav-indent"
                  ><i>›</i>人脸识别增值版</a
                >
              </dd>
              <dd>
                <a href="/product/RV1109.html" class="nav-indent"
                  ><i>›</i>人脸识别 ARM Linux</a
                >
              </dd>
              <dd>
                <a href="/product/arcface_app.html" class="nav-indent"
                  ><i>›</i>APP人脸识别增值版</a
                >
              </dd>
              <dd><a class="nav-indent-title">解决方案</a></dd>
              <dd>
                <a
                  href="/product/dev-tools.html"
                  class="nav-indent"
                  onclick="gtag('event', '开放产品-开发套件', {'event_category' : '导航栏', 'event_label' : 'click11'});"
                  ><i>›</i>开发套件</a
                >
              </dd>
              <dd>
                <a
                  href="/product/arcfacego.html"
                  class="nav-indent"
                  onclick="gtag('event', '开放产品-应用套件', {'event_category' : '导航栏', 'event_label' : 'click12'});"
                  ><i>›</i>应用套件</a
                >
              </dd>
              <dd>
                <a href="/product/arcoffice.html" class="nav-indent"
                  ><i>›</i>人脸考勤系统</a
                >
              </dd>
            </dl>
            <dl class="technology-middle">
              <dt><a href="#">核心技术</a></dt>
              <dd>
                <a
                  href="/technology/faceDetection.html"
                  onClick="gtag('event', '核心技术-人脸检测', {'event_category' : '导航栏', 'event_label' : 'click2'});"
                  ><i>›</i>人脸检测</a
                >
              </dd>
              <dd>
                <a
                  href="/technology/faceTracking.html"
                  onClick="gtag('event', '核心技术-人脸跟踪', {'event_category' : '导航栏', 'event_label' : 'click3'});"
                  ><i>›</i>人脸跟踪</a
                >
              </dd>
              <dd>
                <a
                  href="/technology/faceContrast.html"
                  onClick="gtag('event', '核心技术-人脸比对', {'event_category' : '导航栏', 'event_label' : 'click4'});"
                  ><i>›</i>人脸比对</a
                >
              </dd>
              <dd>
                <a
                  href="/technology/faceLookup.html"
                  onClick="gtag('event', '核心技术-人脸查找', {'event_category' : '导航栏', 'event_label' : 'click5'});"
                  ><i>›</i>人脸查找</a
                >
              </dd>
              <dd>
                <a
                  href="/technology/faceAttribute.html"
                  onClick="gtag('event', '核心技术-人脸属性分析', {'event_category' : '导航栏', 'event_label' : 'click6'});"
                  ><i>›</i>人脸属性分析</a
                >
              </dd>
              <dd>
                <a
                  href="/technology/liveness.html"
                  onClick="gtag('event', '核心技术-活体检测', {'event_category' : '导航栏', 'event_label' : 'click7'});"
                  ><i>›</i>活体检测</a
                >
              </dd>
            </dl>

            <dl>
              <dt><a href="#">应用方案</a></dt>
              <dd><a class="nav-indent-title">应用方案</a></dd>
              <dd>
                <a
                  href="/solution/verification.html"
                  class="nav-indent"
                  onclick="gtag('event', '应用方案-人证核验应用方案', {'event_category' : '导航栏', 'event_label' : 'click13'});"
                  ><i>›</i>人证核验应用方案</a
                >
              </dd>
              <dd>
                <a
                  href="/solution/building.html"
                  class="nav-indent"
                  onclick="gtag('event', '应用方案-人脸门禁应用方案', {'event_category' : '导航栏', 'event_label' : 'click14'});"
                  ><i>›</i>人脸门禁应用方案</a
                >
              </dd>
              <dd><a class="nav-indent-title">解决方案</a></dd>
              <dd>
                <a
                  href="/industry/construction.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧工地', {'event_category' : '导航栏', 'event_label' : 'click15'});"
                  ><i>›</i>智慧工地</a
                >
              </dd>
              <dd>
                <a
                  href="/industry/scenic.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧景区', {'event_category' : '导航栏', 'event_label' : 'click16'});"
                  ><i>›</i>智慧景区</a
                >
              </dd>
              <dd>
                <a
                  href="/industry/community.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧社区', {'event_category' : '导航栏', 'event_label' : 'click17'});"
                  ><i>›</i>智慧社区</a
                >
              </dd>

              <dd>
                <a
                  href="/industry/work.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧办公', {'event_category' : '导航栏', 'event_label' : 'click18'});"
                  ><i>›</i>智慧办公</a
                >
              </dd>

              <dd>
                <a
                  href="/industry/hotel.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧酒店', {'event_category' : '导航栏', 'event_label' : 'click19'});"
                  ><i>›</i>智慧酒店</a
                >
              </dd>

              <dd>
                <a
                  href="/industry/school.html"
                  class="nav-indent"
                  onclick="gtag('event', '解决方案-智慧校园', {'event_category' : '导航栏', 'event_label' : 'click20'});"
                  ><i>›</i>智慧校园</a
                >
              </dd>
            </dl>
            <dl class="technology-middle">
              <dt><a href="#">客户案例</a></dt>
              <dd>
                <a
                  href="/usercase/kdbl.html"
                  onclick="gtag('event', '客户案例-智慧校园', {'event_category' : '导航栏', 'event_label' : 'click21'});"
                  ><i>›</i>智慧校园</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/zld.html"
                  onclick="gtag('event', '客户案例-智慧工地', {'event_category' : '导航栏', 'event_label' : 'click22'});"
                  ><i>›</i>智慧工地</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/shrt.html"
                  onclick="gtag('event', '客户案例-智慧景区', {'event_category' : '导航栏', 'event_label' : 'click23'});"
                  ><i>›</i>智慧景区</a
                >
              </dd>
              <dd>
                <a
                  href="/usercase/zzw.html"
                  onclick="gtag('event', '客户案例-智慧社区', {'event_category' : '导航栏', 'event_label' : 'click24'});"
                  ><i>›</i>智慧社区</a
                >
              </dd>
            </dl>
            <dl>
              <a
                href="/course/index.html"
                style="display: inline-block;width: 100%;line-height: 40px;
                                    padding-left: 60px;font-weight: 700;"
                onclick="gtag('event', '公开课', {'event_category' : '导航栏', 'event_label' : 'click25'});"
                >公开课</a
              >
            </dl>
            <dl>
              <a
                href="/market/index.html"
                style="display: inline-block;width: 100%;line-height: 40px;
                                padding-left: 60px;font-weight: 700;"
                onclick="gtag('event', '产业链市场', {'event_category' : '导航栏', 'event_label' : 'click166'});"
                >产业链市场</a
              >
            </dl>
            <dl>
              <a
                href="/news/index.html"
                style="display: inline-block;width: 100%;line-height: 40px;
                                    padding-left: 60px;font-weight: 700;"
                onclick="gtag('event', '新闻资讯', {'event_category' : '导航栏', 'event_label' : 'click26'});"
                >新闻资讯</a
              >
            </dl>
            <dl>
              <dt><a href="#">帮助和支持</a></dt>
              <dd>
                <a
                  href="/manual/docs#/41"
                  onclick="gtag('event', '帮助与支持-新手指南', {'event_category' : '导航栏', 'event_label' : 'click27'});"
                  ><i>›</i>新手指南</a
                >
              </dd>
              <dd>
                <a
                  href="/manual/docs#/42"
                  onclick="gtag('event', '帮助与支持-常见问题', {'event_category' : '导航栏', 'event_label' : 'click28'});"
                  ><i>›</i>常见问题</a
                >
              </dd>
              <dd>
                <a
                  href="/manual/docs#/123"
                  onclick="gtag('event', '帮助与支持-API文档', {'event_category' : '导航栏', 'event_label' : 'click29'});"
                  ><i>›</i>SDK文档</a
                >
              </dd>
            </dl>
          </div>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import $ from "jquery";
export default {
  name: "Nav",
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }

    var more = true;
    $(window).scroll(function() {
      if ($(window).scrollTop() >= 80) {
        $(".top").addClass("active");
        $(".logo").removeClass("nav-mobile-hide");
        $(".header-title").removeClass("nav-mobile-hide");
      } else {
        $(".top").removeClass("active");
        $(".logo").addClass("nav-mobile-hide"); 
        $(".header-title").addClass("nav-mobile-hide");
      }
    });
    $(".menu").click(function() {
      $(".top-nav").show();
      $(".mobilemenu-screen").css({ display: "block", "z-index": "999" });

      var top = $(document).scrollTop(); //滚动条禁用，画面不变
      $(document).on("scroll.unable", function() {
        $(document).scrollTop(top);
      });
    });
    $(".mobile-nav-btn").click(function() {
      $(".top-nav").hide();
      $(".mobilemenu-screen").css({ display: "none", "z-index": "-1" });

      $(document).unbind("scroll.unable");
      // $("html, body").css("overflowY", "auto");
    });
    $(".mobilemenu-screen").click(function() {
      $(".mobile-nav-btn").trigger("click");
    });
    $(".top-nav .nav-two dt").click(function() {
      if (more) {
        $(this)
          .siblings("dd")
          .show();
        $(this).addClass("less");
        more = false;
      } else {
        $(this)
          .siblings("dd")
          .hide();
        $(this).removeClass("less");
        more = true;
      }
    });
    $(window).resize(function() {
      var wd = $(window).height();
      $(".top-nav").css({ height: wd, overflowY: "auto" });
    });
    $(".mobilemenu-screen").click(function() {
      $(".top-nav").hide();
      $(".mobilemenu-screen").css({ display: "none", "z-index": "-1" });
      $("html, body").css("overflowY", "auto");
    });
    var wd = $(document).height();
    $(".top-nav").css({ height: wd });

    $(".list-nav-cont li").mouseover(function() {
      $(".list-nav-cont li dl dd")
        .stop()
        .animate({ top: "0px", opacity: "1" }, "300");
      $(".list-nav-cont li .title1")
        .stop()
        .animate({ top: "0px", opacity: "1" }, "300");
    });
    $(".list-nav-cont li").mouseleave(function() {
      $(".list-nav-cont li dl dd")
        .stop()
        .animate({ top: "15px", opacity: "0" });
    });
    //登出
    $(".logout").click(function() {
      $.get("/ucenter/user/newlogout", function() {
        gtag("event", "开发者中心-退出登录", {
          event_category: "导航栏",
          event_label: "click35",
        });
        localStorage.setItem("userName", undefined);
        localStorage.setItem("password", undefined);
        window.location.replace("/ucenter/resource/build/index.html#/login");
      });
    });
  },
};
</script>
<style scoped>
@charset "utf-8";
/*头部导航*/
.top {
  width: 100%;
  height: 79px;
  border-bottom: 1px solid transparent;
  position: fixed;
  top: 0;
  z-index: 9999;
}

.top.active {
  background-color: #fff;
  border-bottom: thin solid rgb(204, 204, 204);
}

.top:hover {
  opacity: 1;
}

.top-cont {
  width: 100%;
  margin: 0 auto;
}

.logo {
  display: inline-block;
  float: left;
  width: 250px;
  height: 33px;
  margin-top: 18px;
  margin-left: 40px;
  background: url(/resource/images/logo-ai2.svg) center center no-repeat;
  background-size: 250px 33px;
}

.active .logo {
  background: url(/resource/images/logo-ai.svg) center center no-repeat;
  background-size: 250px 33px;
}

.header-title {
  position: absolute;
  left: 190px;
  bottom: 28px;
  margin: 0 10px;
  line-height: 18px;
  font-size: 18px;
  color: #fff;
}

.header-title:before {
  content: "";
  display: inline-block;
  border-right: 1px solid #fff;
  height: 18px;
  margin-right: 10px;
  vertical-align: bottom;
}

.active .header-title {
  color: #000;
}

.active .header-title:before {
  border-right: 1px solid #000;
}

.logo:hover {
  opacity: 1;
}

.top-nav {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  z-index: 9999999;
  background-color: #fff;
  display: none;
  overflow-y: scroll;
}

.nav-close-cont {
  height: 40px;
}

.mobile-nav-btn {
  width: 15px;
  height: 15px;
  cursor: pointer;
  float: right;
  margin: 12px 17px 0 0;
  opacity: 0.7;
}

.mobile-nav-btn:hover {
  opacity: 1;
}

.top-nav ul {
  border-top: 1px solid #f2f2f2;
}

.top-nav a {
  text-decoration: none;
}

.top-nav ul li > a {
  line-height: 40px;
  padding-left: 30px;
}

.top-nav ul li > a:hover {
  color: #a00f13;
  font-weight: 700;
}

.top-nav .nav-two dt {
  line-height: 40px;
  padding-left: 60px;
  background: url(/resource/images/more.png) 90% center no-repeat;
  background-size: 16px 8px;
  cursor: pointer;
}

.top-nav .nav-two dt.less {
  background: url(/resource/images/less.png) 90% center no-repeat;
  background-size: 16px 8px;
}

.top-nav .nav-two dt a {
  font-weight: 700;
}

.top-nav a {
  color: #333;
  font-size: 13px;
  text-decoration: none;
}

.top-nav .nav-two dt.less a {
  color: #a00f13;
}

.top-nav .nav-two dd {
  line-height: 40px;
  padding-left: 90px;
  display: none;
}

.top-nav .nav-two dd:hover {
  display: block;
  background: rgb(249, 249, 249);
  color: rgb(228, 21, 63);
}

.top-nav .nav-two dd i {
  font-style: normal;
  margin-right: 5px;
  font-size: 20px;
}

.top-nav .nav-two .nav-indent-title {
  color: #333;
  font-weight: 700;
}

.top-nav .nav-two .nav-indent {
  padding-left: 20px;
}

.top-cont .languageBox .active {
  color: #e4153f;
}

.top-cont .languageBox {
  position: absolute;
  right: 60px;
  top: 20px;
  opacity: 0.7;
}

.top-cont .languageBox:hover {
  opacity: 1;
}

.menu {
  width: 28px;
  height: 28px;
  cursor: pointer;
  position: absolute;
  top: 25px;
  right: -53px;
  background: url(/resource/images/menu.png) center center no-repeat;
  display: none;
}

.top.active .menu {
  background: url(/resource/images/menu-active.png) center center no-repeat;
}

.menu img {
  width: 100%;
}

.mobilemenu-screen {
  background: rgba(0, 0, 0, 0.5) 0 0;
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -1;
  will-change: transform;
}

.list-nav-cont {
  height: 79px;
  text-align: right;
  /*width: 75%;*/
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  right: 0;
  float: right;
  margin-right: 18px;
}

.list-nav-cont.fixed {
  position: fixed;
  top: 0;
  z-index: 999999;
}

.list-nav-cont ul {
  display: inline-block;
  line-height: 79px;
}

.list-nav-cont li {
  position: relative;
  display: inline-block;
  margin: 0 15px;
  /* vertical-align: top; */
}

.list-nav-cont li.beforeUserLogin {
  margin-right: 0;
}

.list-nav-cont li > a {
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  display: inline-block;
  line-height: 30px;
  height: 30px;
  cursor: pointer;
  text-decoration: none;
}

.active .list-nav-cont li > a {
  color: rgb(85, 85, 85);
  text-decoration: none;
}

.list-nav-cont li > a:hover {
  border-bottom: 2px solid #bf0000;
}

.list-nav-cont li:not(.afterUserLogin):hover dl {
  display: block;
}

.list-nav-cont li dl dd {
  position: relative;
  /* top: 15px; */
  top: 0;
}

.list-nav-cont li a.active {
  color: #e4153f;
}

.list-nav-cont li dl {
  position: absolute;
  /*left: -50px;*/
  background-color: #f5f5f5;
  z-index: 99;
  width: 120px;
  display: none;
  text-align: left;
  font-weight: 300;
  /*	box-shadow: 0px 0px 3px 1px #c5c6cb;*/
  top: 79px;
  font-size: 0;
  padding-left: 20px;
  padding-bottom: 10px;
}

.list-nav-cont li dl .dl-nac-cont-item {
  display: inline-block;
  vertical-align: top;
}

.list-nav-cont li dl .dl-nac-cont-item .dl-item-title {
  font-size: 16px;
  line-height: 34px;
  border-bottom: 2px solid #ccc;
  color: #333;
  font-weight: 700;
}

.list-nav-cont li dl .dl-nac-cont-item + .dl-nac-cont-item .dl-item-title,
.list-nav-cont li dl .dl-nac-cont-item + .dl-nac-cont-item dd {
  padding-left: 30px;
}

.list-nav-cont2 {
  width: 140px !important;
}

.list-nav-cont3 {
  width: 380px !important;
  left: -180px;
}

.list-nav-cont li dl dd {
  line-height: 36px;
  /* opacity:0;
    top: 15px;
    transition: all 0.3s linear 0.5s; */
}

/* .list-nav-cont li:hover dl dd{
	opacity:1;
	top: 0;
} */
.list-nav-cont li dl dd a {
  color: #000;
  text-decoration: none;
  font-size: 14px;
  /* width: 90%; */
  line-height: 32px;
  display: inline-block;
  vertical-align: top;
}

.list-nav-cont li dl dd a:hover {
  color: #bf0000;
}

.list-nav-cont li dl dd a i {
  margin-right: 5px;
  font-size: 20px;
  font-style: normal;
  padding-top: 12px;
  /*vertical-align:bottom;*/
}

.list-nav-cont li dl dd a:hover {
  color: rgb(142, 16, 17);
}

.list-nav-cont li .developer-center {
  background: #bf0000 url(/resource/images/center.png) 10px center no-repeat;
  display: inline-block;
  padding: 0 10px 0 30px;
  color: #fff;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 300;
}

.list-nav-cont li.afterUserLogin {
  display: none;
}

.top.active .list-nav-cont li .developer-center {
  color: #fff;
}

.top .list-nav-cont li .developer-center:hover {
  border: none;
  background-color: #a70101;
}

.list-nav-cont li .developer-center-reg {
  display: inline-block;
  padding: 0 20px;
  background-color: #bf0000;
  color: #fff;
  border-radius: 2px;
  margin-left: 20px;
}

.active .list-nav-cont li > a.developer-center-reg {
  color: #fff;
}

.list-nav-cont li .developer-center-reg:hover {
  border: none;
  background-color: #a70101;
}

.list-nav-cont li .developer-user {
  display: inline-block;
  vertical-align: middle;
  margin-left: 25px;
  position: relative;
}

.list-nav-cont li .developer-user .login-icon {
  width: 80px;
  height: 79px;
  background: url(/resource/images/login-icon.png) left center no-repeat;
  cursor: pointer;
  padding-left: 36px;
}

.list-nav-cont li .developer-user dl {
  border-radius: 3px;
  left: auto;
  right: 0;
}

.list-nav-cont li .developer-user:hover dl {
  display: block;
}

.list-nav-cont li .developer-user dl dd {
  padding-left: 30px;
  font-size: 14px;
}

.list-nav-cont li .developer-user dl .userinfo-name {
  width: calc(100% - 40px);
  background: url(/resource/images/userinfo-name.png) left center no-repeat;
}
.list-nav-cont li .developer-user dl .userinfo-name a {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-nav-cont li .developer-user dl .userinfo-account.account-ok {
  background: url(/resource/images/account-ok.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-account.accounting {
  background: url(/resource/images/accounting.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-account.account-no {
  background: url(/resource/images/account-no.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link {
  padding-left: 0;
}

.list-nav-cont li .developer-user dl .userinfo-link {
  padding-left: 30px;
  display: block;
  background: url(/resource/images/userinfo-link.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link:hover {
  color: #bf0000;
  background: url(/resource/images/userinfo-link-active.png) left center
    no-repeat;
}

/* .list-nav-cont li .developer-user dl .userinfo-link a {
    padding-left: 30px;
    display: block;
    background: url(/resource/images/userinfo-link.png) left center no-repeat;
}

.list-nav-cont li .developer-user dl .userinfo-link:hover a {
    color: #BF0000;
    background: url(/resource/images/userinfo-link-active.png) left center no-repeat;
} */

.list-nav-cont li .developer-user dl .logout {
  background: url(/resource/images/logout.png) left center no-repeat;
  cursor: pointer;
}

.list-nav-cont li .developer-user dl .logout:hover {
  color: #bf0000;
  background: url(/resource/images/logout-active.png) left center no-repeat;
}

.list-nav-cont li .developer-user .developer-user-center {
  color: #fff;
}

.list-nav-cont .solution-1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: 10px;
}

.list-nav-cont .solution-2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 15px;
  padding-left: 10px;
}

.list-nav-cont .solution-3 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.list-nav-cont .solution-2 dd {
  width: 140px;
}

.list-nav-cont .title2 {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #000000;
}

.list-nav-cont .title1 {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #000000;
}

.top.active .list-nav-cont li .developer-user .developer-user-center {
  color: rgb(85, 85, 85);
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.login-icon-mobile {
  position: absolute;
  right: 68px;
  top: 10px;
  display: none;
}

.login-icon-mobile img {
  width: 30px;
  height: 30px;
}

@media screen and (max-width: 1200px) {
  .list-nav-cont {
    margin-right: 78px;
  }

  .nav-mobile-hide ul {
    display: none;
  }

  .menu {
    display: block;
  }
}

@media screen and (min-width: 981px) {
  .nav-mobile-hide {
    display: inline-block;
  }
}

@media screen and (max-width: 640px) {
  .login-icon-mobile {
    display: block;
  }

  .top {
    height: 50px;
  }

  .top-nav {
    width: 100%;
  }

  .header-title {
    display: none;
  }

  .logo {
    margin: 10px;
    background-size: 100%;
    background-position: left;
    width: 125px;
  }

  .active .logo {
    margin: 10px;
    background-size: 100%;
    background-position: left;
    width: 125px;
  }

  .menu {
    top: 10px;
    right: -65px;
  }

  .logo {
    background-position: left;
  }
}

.solution-first,
.example,
.help,
.application {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue